export default __webpack_public_path__ + "static/media/hoa_need_help.cecc5397.jpg";